// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"Slider_SideDrawer__3q5To","Open":"Slider_Open__250Cy","Close":"Slider_Close__hsvCO","Logo":"Slider_Logo__Dzi0w"};